import { isIpValid } from 'core/util/ip';

export default {
  message: 'This field requires a comma-separated list of IP addresses and/or subnets',
  fn: (value) => {
    let ips = value;
    if (!Array.isArray(value) && typeof value === 'string') {
      ips = value.split(',');
    }

    return Array.isArray(ips) && ips?.every((ip) => isIpValid(ip));
  }
};
